import Api from 'src/services/ApiService';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CommonAxiosResponse } from 'src/types';
import {
  GetTaxCertificateListResponse,
  TaxCertificateDetailsResponse,
  GetTaxCertificateListPayload,
  UpdateTaxCertificateRequest,
  UpdateTaxCertificateResponse
} from './types';

export const taxCertificateListThunk = createAsyncThunk<
  CommonAxiosResponse<GetTaxCertificateListResponse>,
  GetTaxCertificateListPayload
>('taxCertificate/taxCertificateListThunk', async (data) => {
  const response = await Api.get(`/po/tax_certificate/get`, data);
  return response;
});

export const taxCertificateDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<TaxCertificateDetailsResponse>,
  number
>('taxCertificate/taxCertificateDetailsThunk', async (tax_certificate_id) => {
  const response = await Api.get(
    `/po/tax_certificate/get/${tax_certificate_id}`
  );
  return response;
});

export const taxCertificateUpdateThunk = createAsyncThunk<
  CommonAxiosResponse<UpdateTaxCertificateResponse>,
  UpdateTaxCertificateRequest
>('taxCertificate/taxCertificateUpdateThunk', async (data) => {
  const response = await Api.patch(
    `/po/tax_certificate/update/${data.tax_certificate_id}`,
    data
  );
  return response;
});
